'use client';

import { mercadoPagoService } from '@/api/mercadopago/mercadoPagoApi';
import type React from 'react';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

interface MercadoPagoProtectedRouteProps {
  children: React.ReactNode;
}

export const MercadoPagoProtectedRoute: React.FC<
  MercadoPagoProtectedRouteProps
> = ({ children }) => {
  const [hasMercadoPagoAuth, setHasMercadoPagoAuth] = useState<boolean | null>(
    null,
  );

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const status = await mercadoPagoService.hasMercadoPagoCredentials();
        setHasMercadoPagoAuth(status);
      } catch (error) {
        console.error('Error checking MercadoPago auth:', error);
        setHasMercadoPagoAuth(false);
      }
    };

    checkAuthStatus();
  }, []);

  if (hasMercadoPagoAuth === null) {
    return null;
  }

  if (!hasMercadoPagoAuth) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
